import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, ViewChild, Output, EventEmitter, Inject, PLATFORM_ID, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { ProductZoomComponent } from 'src/app/main-theme/global-theme/pages/products/product/product-zoom/product-zoom.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { ProductDialogComponent } from 'src/app/shared/products-carousel/product-dialog/product-dialog.component';
import { Settings, AppSettings } from 'src/app/app.settings';
import { checkDeliveryCalenderAndCutOffTime, getLocalStorage, checkDeliveryCalendarOrderStatus, checkCutoffDate, checkCutoffTime, } from 'src/app/theme/utils/util-functions';
import { DatePipe, DecimalPipe, isPlatformBrowser } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { FeatureTagObject } from 'src/app/types/feature-tags';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Subscription, Subject, of } from 'rxjs';
import { ScreenBreakpoint } from 'src/app/theme/utils/screen-breakpoint';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class LittleFarmProductComponent implements OnInit, AfterViewInit {
  @ViewChild('zoomViewer', { static: true }) zoomViewer;
  @ViewChild(SwiperDirective, { static: true }) directiveRef: SwiperDirective;
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  // Use @Input to receive data from the parent component
  // @Input() cartData: { items: number; total: number };

  // Use @Output to send data back to the parent component
  // @Output() cartDataChange: EventEmitter<{ items: number; total: number }> = new EventEmitter();

  public config: SwiperConfigInterface = {};
  public productMainSliderConfig: SwiperConfigInterface = {};
  public product;
  imageUrl = environment.imageUrl;
  public image: any;
  public zoomImage: any;
  private sub: any;
  public form: FormGroup;
  selectedDeliveryCalendar = {};
  storeDetails = {};
  storeDetailsJson = {};
  params;
  cartSubscription;
  products = [];
  subService;
  thumbImage;
  fullImage;
  mainImage;
  mainImageName;
  public settings: Settings;
  featureTags: FeatureTagObject = <FeatureTagObject>{};
  public relatedProducts = [];
  public productTabs = [];
  public productDescription;
  myThumbnail = "https://wittlock.github.io/ngx-image-zoom/assets/thumb.jpg";
  myFullresImage = "https://wittlock.github.io/ngx-image-zoom/assets/fullres.jpg";
  shoppingCartStatusBarData = {
    items: 0,
    total: 0.00
  };
  totalTaxCollectedAmount: number = 0;
  loading: boolean = false
  loadingRelatedProduct: boolean = false
  n_productDescription:any;
  FeatureTagProbadgeImgFit: boolean = false;
  private recurringSubscription = new Subscription();
  public isMobile = false;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private decimalPipe: DecimalPipe,
    public MatTabsModule: MatTabsModule,
    public appSettings: AppSettings,
    private subscription: SubscriptionService,
    private router: Router,
    public dialog: MatDialog,
    public formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private sharedDataService: SharedDataService,
    public notification: NotificationService,
    public meta: Meta,
    private screenBreakpoint: ScreenBreakpoint,
    private sanitizer: DomSanitizer
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    // if (isPlatformBrowser(this.platformId)) {
    //   // This block will only run on the browser
    //   console.log('This is client-side rendering');
    // }
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.isMobile = this.screenBreakpoint.checkScreenBreakpoint('screen and (max-width: 959px)');
    this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];    
    this.storeDetailsJson = this.activatedRoute.snapshot.data['store']['response']['data']['store_json'];
    this.FeatureTagProbadgeImgFit = !!this.featureTags && this.featureTags['sf_product_badges_issues'] ? true : false ;

    this.apiService.getStoreDetails()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (isPlatformBrowser(this.platformId) && result['response']['status'] === 1) {
        if (!!result['response']['data']['store']) {
          this.storeDetails = result['response']['data']['store'];
          this.storeDetailsJson = result['response']['data']['store_json'];
        }
      }
    })
    this.selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));


    this.sub = this.activatedRoute.params
    .pipe(takeUntil(this.destroy$))
    .subscribe(params => {
      this.params = params ? params : this.router.url.split('/')[2]
      if (this.params) {
        this.getProduct(params);
        if(isPlatformBrowser(this.platformId)){
          this.getProductPairs();
        }
      }
    }, err => {
      let routeparams = this.router.url.split('/')[2]
      this.getProduct(routeparams);
      if(isPlatformBrowser(this.platformId)){
        this.getProductPairs();
      }
    });
    this.cartSubscription = this.sharedDataService.cartResponse$
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (this.apiService.loggedIn()) {
        this.getProduct(this.params);
        // this.getCartCount();
      }
    })
    if(!!this.featureTags && this.featureTags['ftag_sf_recurring_popup_split_date_issue']){
      this.recurringSubscription.add(
        this.sharedDataService.recurringUpdate$
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          if(data){
            this.getProduct(this.params);
            this.getCartCount();
          }
        })
      );
    }
    this.getCartCount();
    // this.subService = this.subscription.getSubject().subscribe(val => {
    //   if (val['refresh'] && this.apiService.loggedIn()) {
    //     this.getProduct(this.params);

    //     this.getCartCount();
    //   }
    // });
    this.form = this.formBuilder.group({
      'review': [null, Validators.required],
      'name': [null, Validators.compose([Validators.required, Validators.minLength(4)])],
      'email': [null, Validators.compose([Validators.required, emailValidator])]
    });
  }

  ngAfterViewInit() {
  }
  
  getProductPairs() {
    this.loadingRelatedProduct = true
    if (this.params['code'] != null && this.params['code'] != undefined) {
      var params_val = this.storeDetails['id'] + "/" + encodeURIComponent(this.params['code']);
    } else {
      var params_val = this.storeDetails['id'] + "/" + encodeURIComponent(this.params['code']);
    }
    this.apiService.getProductPairStats(params_val)
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      this.loadingRelatedProduct = false
      if (isPlatformBrowser(this.platformId) && result['response']['status'] === 1) {
        // if(result['response']['status'] === 6) {
        // console.log("check result response",result['response']['data'])
        // this.relatedProducts = result['response']['data']['products'];  
        // this.relatedProducts = result['response']['data']['similar_products'];  
        this.relatedProducts = result['response']['data']['also_added'].length > 0 ? result['response']['data']['also_added'] : result['response']['data']['similar_products'];
        this.relatedProducts['storeDetailsJson'] = this.storeDetailsJson;
        this.relatedProducts['storeDetails'] = this.storeDetails;
        if(!!this.featureTags && this.featureTags['sf_similar_products']){
          this.config = {
            observer: true,
            slidesPerView: 4,            
            keyboard: true,
            navigation: true,
            pagination: false,
            loop: false,
            preloadImages: false,
            lazy: true,
            freeMode: true,
            breakpoints: {
              645: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              950: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              }
            }
          }
        }else{
          this.config = {
            observer: false,
            slidesPerView: 4,
            spaceBetween: 10,
            keyboard: true,
            navigation: true,
            pagination: false,
            loop: false,
            preloadImages: false,
            lazy: true,
            breakpoints: {
              480: {
                slidesPerView: 2
              },
              600: {
                slidesPerView: 3,
              }
            }
          }
        }
      }
    });
  }
  getProduct(params) {
    this.loading = true

    this.productTabs = [];
    let query
    if (this.params['code'] != null && this.params['code'] != undefined) {
      query = {
        website_url: params['code']
      };
    } else {
      query = {
        website_url: params['code']
      };
    }
    if (checkDeliveryCalenderAndCutOffTime() === true) {
      query['edit_cart'] = 3;
    }
    this.apiService.searchProducts(query)
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      this.loading = false
      if (result['response']['status'] === 1) {
        this.product = result['response']['data']['products']['products'][0];
        if(!!this.featureTags && this.featureTags['sf_product_description_issue']){
          this.n_productDescription = this.product['product']['website_description'].replace(/<div[^>]*role="tabpanel"[^>]*>[\s\S]*?<\/div>/g, '');       
        }
        if (isPlatformBrowser(this.platformId)) {
          // Product Description 
          const parser = new DOMParser();
          const doc2 = parser.parseFromString(this.product['product']['website_description'], 'text/html');
          const doc = parser.parseFromString(this.product['product']['website_description'], 'text/html');
          if (doc) {
            doc.querySelectorAll('[role="tab"]').forEach(tabheader => {
              var Tabid = tabheader.getAttribute('aria-controls');
              this.productTabs.push({
                'header': tabheader.innerHTML,
                'Tabid': Tabid
              })
            });
            if (this.productTabs.length > 0) {
              this.productTabs.forEach((tabbody, key) => {
                var TabContent = doc.getElementById(tabbody.Tabid.toString()).innerHTML;
                this.productTabs[key]['TabContent'] = TabContent;
              });
              var HtmlDiv = doc2.querySelector('[role="tabpanel"]');
              HtmlDiv.remove();
            }
            this.productDescription = doc2.body.textContent ? doc2.body.textContent : "";
          }

        }

        if(!!this.featureTags && this.featureTags['sf_seo']){
            let title = `${this.product['product']['description']} - ${this.storeDetails['name']}`
            let pageTitle = this.checkTitleSize(title);
            this.title.setTitle(pageTitle);
        }else{
          this.title.setTitle(`${this.product['product']['description']} - ${this.title.getTitle()}`);          
        }
        if (this.product['product']['meta_description']) {
          this.meta.updateTag({ name: 'description', content: this.product['product']['meta_description'] });
        }
        this.product['storeDetails'] = this.storeDetails;
        this.subscription.subjectNext({ setbreadcrumb: true, productName: this.product['product']['description'] });
        // this.product['images'] = [{medium: this.product['product']['product_code'] }];
        this.zoomImage = this.product['product']['product_image1'];
        this.thumbImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image1'].split('.')[0]}_md.${this.product['product']['product_image1'].split('.')[1]}` : 'assets/images/no_image_found_md.png';
        this.fullImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/original/${this.product['product']['product_image1'].split('.')[0]}.${this.product['product']['product_image1'].split('.')[1]}` :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? `${this.imageUrl}${this.storeDetails['id']}/original/${this.product['product']['product_image2'].split('.')[0]}.${this.product['product']['product_image2'].split('.')[1]}` :
            'assets/images/no_image_found_md.png';
        if(!!this.featureTags && this.featureTags['sf_product_img_slider']){
          this.mainImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image1'].split('.')[0]}_md.${this.product['product']['product_image1'].split('.')[1]}` :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image2'].split('.')[0]}_md.${this.product['product']['product_image2'].split('.')[1]}` :
            'assets/images/no_image_found_md.png';
        }else{
          this.mainImage = !!this.product['product']['product_image1'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image1'].split('.')[0]}_lg.${this.product['product']['product_image1'].split('.')[1]}` :
            !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? `${this.imageUrl}${this.storeDetails['id']}/${this.product['product']['product_image2'].split('.')[0]}_lg.${this.product['product']['product_image2'].split('.')[1]}` :
              'assets/images/no_image_found_md.png';
        }
        this.mainImageName = !!this.product['product']['product_image1'] ? this.product['product']['product_image1'] :
          !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? this.product['product']['product_image2'] : 'assets/images/no_image_found_md.png';
        if(!!this.featureTags && this.featureTags['ftag_product_images_related_issues']){
          const product = this.product['product'];
          this.product['secImages'] = [] as { medium: string }[];

          for (let i = 1; i <= 5; i++) {
            const imageKey = `product_image${i}` as keyof typeof product;
            const imageValue = product[imageKey];

            if (imageValue) {
              this.product['secImages'].push({ medium: imageValue });
            }
          }
          const imageCount = this.product['secImages'].length;
          const slidesPerView = Math.min(imageCount, 2);
          
          this.productMainSliderConfig = {
            observer: true,
            slidesPerView,
            keyboard: true,
            navigation: imageCount > 1, // hide arrows if 1 or 0 images
            pagination: false,
            loop: false,
            preloadImages: false,
            lazy: true,
            freeMode: true,
            breakpoints: {
              380: {
                slidesPerView:  1,
                spaceBetween: 10
              },
              645: {
                slidesPerView: 2,
                spaceBetween: 10
              },
              768: {
                slidesPerView:  3,
                spaceBetween: 10
              },
              960: {
                slidesPerView: 4,
                spaceBetween: 10
              },
              1200: {
                slidesPerView: 2,
              }
            }
          };

        }else{
          this.product['secImages'] = !!this.product['product']['product_image1'] && !!this.product['product']['product_image2'] ? [{ medium: this.product['product']['product_image1'] }, { medium: this.product['product']['product_image2'] }] :
          !!this.product['product']['product_image1'] && !!this.product['product']['product_image2'] === false ? [{ medium: this.product['product']['product_image1'] }] :
            !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2'] ? [{ medium: this.product['product']['product_image2'] }] : [];
        }
      } else if (result['response']['status'] === 6) {
        this.loading = false
        this.router.navigateByUrl('**', { skipLocationChange: true });
      }
    }, (error) => {
      if (error) {
        console.log(error);
        this.loading = false
        if (isPlatformBrowser(this.platformId) && error['status'] === 404) {
          this.router.navigateByUrl('**', { skipLocationChange: true });
        }
      }
      return of(null); // In SSR, Prevent memory leaks by returning a safe value
    });
  }
  checkTitleSize(title : string): string {
    const maxTitleLength = 60; 
    if (title.length > maxTitleLength) {
      title = title.slice(0, maxTitleLength - 3) + '...'; 
    }
  
    return title;
  }

  public selectImage(image) {
    this.image = image.medium;
    if(!!this.featureTags && this.featureTags['sf_product_img_slider']){
      this.mainImage = `${this.imageUrl}${this.storeDetails['id']}/${image.medium.split('.')[0]}_md.${image.medium.split('.')[1]}`;
    }else{
      this.mainImage = `${this.imageUrl}${this.storeDetails['id']}/${image.medium.split('.')[0]}_lg.${image.medium.split('.')[1]}`;
    }
    this.fullImage = `${this.imageUrl}${this.storeDetails['id']}/original/${image.medium.split('.')[0]}.${image.medium.split('.')[1]}`;
    this.mainImageName = image.medium;
    // this.zoomImage = image.medium;
  }

  public onMouseMove(event, zoom = 1) {
    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = event.currentTarget;
      offsetX = event.offsetX;
      offsetY = event.offsetY;
      x = offsetX / image.offsetWidth * 100;
      y = offsetY / image.offsetHeight * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];

      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = "block";
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }


    }
  }

  public onMouseLeave(event) {
    this.zoomViewer.nativeElement.children[0].style.display = "none";
  }

  public openZoomViewer() {
    this.dialog.open(ProductZoomComponent, {
      data: { image: this.mainImageName, description: this.product['product']['description'] },
      panelClass: 'zoom-dialog'
    });
  }
  openProductDialog(event, product) {
    this.onOpenProductDialog.emit(product);
    product['storeDetails'] = this.storeDetails;
    // product['images'] = [{medium: product['product']['product_image1']}]
    // if(!!product['product']['product_image2'] && product['product']['product_image2'] !== "null") {
    //   product['images'][1] = {medium: product['product']['product_image2']};
    // }
    product['images'] = !!product['product']['product_image1'] && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image1'] }, { medium: product['product']['product_image2'] }] :
      !!product['product']['product_image1'] && !!product['product']['product_image2'] === false ? [{ medium: product['product']['product_image1'] }] :
        !!product['product']['product_image1'] === false && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image2'] }] : [{ medium: '' }];
    const dialogRef = this.dialog.open(ProductDialogComponent, {
      minWidth: '90vw',
      data: product,
      panelClass: 'product-dialog',
      direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });
    dialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      // this.getProduct(this.params);
      if (this.apiService.loggedIn() === false) {
        getLocalStorage(this.storeDetails, this.decimalPipe);
      }
    });

  }
  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
    this.sub.unsubscribe();
    !!this.subService && this.subService.unsubscribe();
    if(!!this.featureTags && this.featureTags['sf_mobile_view_issue_2']){
    }
    if(!!this.featureTags && this.featureTags['ftag_sf_recurring_popup_split_date_issue']){
      if(this.recurringSubscription){
        this.recurringSubscription.unsubscribe();
      }
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSubmit(values: Object): void {
    if (this.form.valid) {
      //email sent
    }
  }
  setDefaultPic() {
    this.mainImage = 'assets/images/no_image_found_md.png';
    this.mainImageName = 'assets/images/no_image_found_md.png';
  }
  /*start*/
  goToCart() {
    this.router.navigate(['cart']);
  }
  getSaleOrderDetails() {
    this.loading = true;
    this.apiService.getSaleOrders()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (isPlatformBrowser(this.platformId) && data['response']['status'] === 1) {
        let resData = data['response']['data'];
        let undeliveredOrder = resData['undelivered_order'];
        let saleOrderItems = undeliveredOrder[0] && undeliveredOrder[0]['sale_order_items'];
        let totalPayable = undeliveredOrder[0] && undeliveredOrder[0]['total_payable'];
        // if (this.featureTags['taxes_in_storefront']) {
          this.totalTaxCollectedAmount = undeliveredOrder[0]['tax_collected'];
        // }
        this.loading = false;

        this.calculateCartData(saleOrderItems, totalPayable);
      }
    });
  }

  getRecurringDetails(cartProduct: Array<object>, notCartProduct: Array<object>, notCartProductIds: Array<number>) {
    this.apiService.getRecurring()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (isPlatformBrowser(this.platformId) && data['response']['status'] === 1) {
        let recurringItems = data['response']['data']['recurring_products'];
        let recurringProducts = recurringItems.filter(product => {
          let productIndex = notCartProduct.filter(val => val !== undefined)
            .findIndex(el => el['product']['id'] === product['product_id']);
          if (this.datePipe.transform(product['delivery_date'], 'yyyy-MM-dd') === product['recurring_date'] ||
            notCartProductIds.indexOf(product['product']['id']) >= 0) {
            if (productIndex >= 0 && notCartProduct[productIndex] !== undefined) {
              product['recurring_date'] = product['delivery_date'];
              product['quantity'] = notCartProduct[productIndex]['quantity'];
              product['frequency'] = notCartProduct[productIndex]['frequency'];
              product['cartId'] = notCartProduct[productIndex]['id'];
              product['extended_price'] = notCartProduct[productIndex]['extendedprice'];
            }
            return product;
          }
        });
        let concatedArray = cartProduct.concat(recurringProducts);
        this.calculateCartData(concatedArray);
      }
    });
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      if (checkDeliveryCalendarOrderStatus("undelivered") &&
        (checkCutoffDate('!==') || checkCutoffDate('===') && checkCutoffTime('<'))) {
        this.getSaleOrderDetails();
      } else if (checkDeliveryCalenderAndCutOffTime() === true) {
        this.getSaleOrderDetails();
      } else {
        // this.getCartDetails();
      }

    } else {
      let cartProduct = JSON.parse(sessionStorage.getItem('cart'));
      this.calculateCartData(cartProduct);
    }
  }
  /* Calculate Cart Count Data Start */
  calculateCartData(data: Array<Object>, total?: any) {
    let bottleQty = 0;
    let totalBottlePrice = 0;
    let subTotal = 0;
    let totalItems = !!data ? data.length : 0;

    data && data.length > 0 && data.forEach(product => {
      let uom = product['product']['cb_unit_of_measurement']['uom_reference_id'];
      let quantity = uom === 1 ? parseFloat(product['quantity']) : parseInt(product['quantity']);
      if (!!total === false) {
        if (!!product['bottleQty'])
          bottleQty += parseInt(product['bottleQty']);
        else if (product['product']['bottle_charge']) {
          bottleQty += parseInt(product['quantity']);
        }
        if (!!product['extended_price']) {
          subTotal += parseFloat(this.decimalPipe.transform(this.decimalPipe.transform(product['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, ''));
        } else if (!!product['extendedprice']) {
          if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform((product['product']['sell_in_conv_rate'] * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(product['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
            subTotal += parseFloat(productPrice);
          }else{
            let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'nos' ? this.decimalPipe.transform(this.decimalPipe.transform((product['product']['sell_in_conv_rate'] * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(product['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          subTotal += parseFloat(productPrice);
          }
        } else {
          let productPrice = !!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform((parseFloat(product['product']['sell_in_conv_rate']) * quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform((quantity * parseFloat(product['product']['retail_price'])), '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          subTotal += parseFloat(productPrice);
        }
      }
    });

    if (!!total === false) {
      totalBottlePrice = bottleQty * this.storeDetails['rate_per_bottle'];
      let storeDeliveryFee = this.storeDetails['delivery_fee'];
      let deliveryUpperLimit = this.storeDetails['delivery_upper_limit'];
      let deliveryFee = subTotal >= deliveryUpperLimit && deliveryUpperLimit > 0 ? 0 : storeDeliveryFee;
      total = totalBottlePrice + subTotal + deliveryFee;
      // if (this.featureTags['taxes_in_storefront']) {
        if (this.totalTaxCollectedAmount > 0) {
          total = total + this.totalTaxCollectedAmount;
        }
      // }
    }
    this.shoppingCartStatusBarData = { items: totalItems, total: totalItems > 0 ? total : 0 };
    // if (this.apiService.loggedIn()) {
      this.sharedDataService.cartDataSource.next(this.shoppingCartStatusBarData);
    // }
  }
  /* End */
  getUrl(product) {
    if (product) {
      var desp = product['product']['description'].toLowerCase();
      if (product['product']['website_url']) {
        if (product && product['product']) {
          const productUrl = product['product']['website_url'] ? product['product']['website_url'] : product['product']['id'];
          this.router.navigate(['/products', productUrl]);
        }
      }
    }
    this.config = {
      observer: false,
      slidesPerView: 4,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3,
        }
      }
    }
  }

  openInNewTab(product: any) {
    const productUrl = product['product']['website_url'] ? product['product']['website_url'] : product['product']['id'];
    window.location.href = `products/${productUrl}`;
  }

  sanitizeContent(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}